import React from 'react';
import { RefreshCw } from 'lucide-react';
import { STORE_DISPLAY_NAME } from '../constants/branding';

type UpdatePromptProps = {
  visible: boolean;
  updating?: boolean;
};

const UpdatePrompt: React.FC<UpdatePromptProps> = ({
  visible,
  updating = false,
}) => {
  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-5 z-[90] flex justify-center px-4">
      <div className="pointer-events-auto w-full max-w-md rounded-[28px] border border-emerald-200 bg-white p-4 shadow-[0_18px_50px_rgba(15,23,42,0.18)]">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl bg-emerald-50 p-3 text-emerald-700">
            <RefreshCw className={`h-5 w-5 ${updating ? 'animate-spin' : ''}`} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-slate-900">
              {updating ? `Updating ${STORE_DISPLAY_NAME}...` : 'A new version is ready'}
            </div>
            <div className="mt-1 text-sm text-slate-500">
              {updating
                ? 'Please wait a moment while the latest screen is loaded.'
                : 'The app will switch to the latest version automatically.'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;
